<template>
    <el-row>
        <div id="toolbar" style="display: none">
        </div>
        <div style="padding: 5px 0; color: #ccc"></div>
        <div id="wangEditor" style=" box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);height: 400px;" > <!--可使用 min-height 实现编辑区域自动增加高度-->
        </div>
    </el-row>
</template>

<script>
    import E from "wangeditor"
    export default {
        name: "about",

        data(){
            return {
                settingInfoForm:{
                    about:'',
                    majorMaintain:0,
                    miniMaintain:0,
                    id:1,
                    rules: {
                        majorMaintain: [{required: true, message: '请输入大周期', trigger: 'blur'}],
                        miniMaintain: [{required: true, message: '请输入小周期', trigger: 'blur'}],
                    },
                },
                wangEditor:null,
            }
        },
        mounted(){
            this.getMaintainInfo()
            let e=new E('#toolbar','#wangEditor')
            e.create()
            this.wangEditor=e
        },
        methods:{
            getMaintainInfo(){
                this.$http.get('/manage/setting/get.do').then(function (resp) {
                    if(resp.data.success){
                        this.settingInfoForm.about=resp.data.data.about;
                        this.settingInfoForm.majorMaintain=resp.data.data.majormaintian;
                        this.settingInfoForm.miniMaintain=resp.data.data.minimaintain;
                        this.settingInfoForm.id=resp.data.data.id
                        this.wangEditor.txt.html(this.settingInfoForm.about)
                        this.wangEditor.$textElem.attr('contenteditable',false)
                    }else{
                        this.$message.error('加载通用设置信息错误')
                    }
                }.bind(this)).catch(err=>{
                    console.info(err)
                })
            },
        }

    }
</script>

<style scoped>

</style>
